var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelAppointmentMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "appointment-missed-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M10.562,0a10.562,10.562,0,0,0,0,21.125c.279,0,.54-.032.812-.051v-3.3a6.929,6.929,0,0,1-.812.1,7.312,7.312,0,1,1,7.312-7.312,6.929,6.929,0,0,1-.1.812h3.3c.019-.273.051-.533.051-.812A10.587,10.587,0,0,0,10.562,0Zm0,4.875a.81.81,0,0,0-.813.812V9.75H7.312a.812.812,0,1,0,0,1.625h3.25a.81.81,0,0,0,.812-.812V5.687A.81.81,0,0,0,10.562,4.875Zm0,0",
    fill: "#081831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M14.037,8.019A6.5,6.5,0,1,0,19.1,9.9,6.478,6.478,0,0,0,14.037,8.019ZM12.2,10.57a1.632,1.632,0,0,1,1.149.482L14.5,12.2l1.149-1.149a1.625,1.625,0,1,1,2.3,2.3L16.8,14.5l1.149,1.149a1.625,1.625,0,0,1-2.3,2.3L14.5,16.8l-1.149,1.149a1.625,1.625,0,0,1-2.3-2.3L12.2,14.5l-1.149-1.149A1.631,1.631,0,0,1,12.2,10.57Zm0,0",
    transform: "translate(5 5.001)",
    fill: "#d9152d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAppointmentMobileIcon);
export default __webpack_public_path__ + "static/media/cancelAppointmentMobileIcon.35000d99fb72385fad3b36dccc92d7fa.svg";
export { ForwardRef as ReactComponent };